import * as actions from "../constants/actionTypes";
import * as utils from "../utils/utils";

const initialState = {
    vessels: [],
    loading: false,
    saving: false,
    deleting: false
};

export default function vessel(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_VESSEL:
            newState.loading = true;
            break;

        case actions.SAVING_VESSEL:
            newState.saving = true;
            break;

        case actions.RECEIVED_VESSELS:
            newState.vessels = utils.mapById(action.payload);
            newState.loading = false;
            break;

        case actions.SAVED_VESSEL:
            let found = false;

            for (let i = 0; i < newState.vessels.length; i++) {
                if(newState.vessels[i].id === action.payload.id){
                    found = true;

                    newState.vessels[i] = action.payload;
                }
            }

            if(!found) {
                newState.vessels.add(
                    action.payload
                );
            }

            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_VESSELS:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.DELETING_VESSEL:
            newState.deleting = true;
            break;

        case actions.DONE_DELETING_VESSEL:
            newState.deleting = false;
            break;

        default: break;
    }

    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/vessel.js